<template>
  <input type="tel" :required="required" :min="min" v-model="viewValue" :disabled="disabled" :class="ClassName?'form-control '+ClassName:'form-control'" :placeholder="placeholder?placeholder:''">
  <input :name="name" :value="value2" type="hidden" readonly/>
</template>
<script>
export default {
  name: "NumberInput",
  data: () =>
  {
    return {
      viewValue:'',
      value2:'',
    }
  },
  mounted()
  {
    this.viewValue = (this.value?this.value.toString():'');
    this.render();
  },
  methods:{
    render()
    {
      const x = this.viewValue.replace(/\D/g, "");
      this.value = x;
      this.value2 = x;
      this.viewValue = x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");;
    },
  },
  watch: {
    viewValue()
    {
      this.render();
    },
  },
  emits: ['update:modelValue'],
  props:['ClassName','disabled','name','placeholder','required','min','modelValue'],
  computed: {
    value: {
      get() {
        return this.modelValue
      },
      set(value) {
        this.$emit('update:modelValue', value)
      }
    }
  },
}
</script>

<style scoped>

</style>
